
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/clicker-support",
      function () {
        return require("private-next-pages/clicker-support.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/clicker-support"])
      });
    }
  